<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center flex-right">
        <div class="box-header-left flex flex-center"></div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible3 = true"
          ></el-button>
          <el-button type="primary" icon="el-icon-delete" class="active-icon"
            >删除</el-button
          >
          <el-button type="primary" icon="el-icon-plus" class="active-icon"
            >新建</el-button
          >
        </div>
      </div>
      <!--内容-->
      <div class="box-content">
        <div class="box-item box-half box-bc box-active">
          <div class="box-item-text">
            <div class="box-item-title">78.5分</div>
            <div>
              <span class="gray-text">名称：</span
              ><span class="white-text">斯考特实验室精选</span>
            </div>
            <div>
              <span class="gray-text">日期：</span
              ><span class="white-text">2021.06.25</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half box-bc">
          <div class="box-item-text">
            <div class="box-item-title">78.5分</div>
            <div>
              <span class="gray-text">名称：</span
              ><span class="white-text">斯考特实验室精选</span>
            </div>
            <div>
              <span class="gray-text">日期：</span
              ><span class="white-text">2021.06.25</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half box-bc">
          <div class="box-item-text">
            <div class="box-item-title">78.5分</div>
            <div>
              <span class="gray-text">名称：</span
              ><span class="white-text">斯考特实验室精选</span>
            </div>
            <div>
              <span class="gray-text">日期：</span
              ><span class="white-text">2021.06.25</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half box-bc">
          <div class="box-item-text">
            <div class="box-item-title">78.5分</div>
            <div>
              <span class="gray-text">名称：</span
              ><span class="white-text">斯考特实验室精选</span>
            </div>
            <div>
              <span class="gray-text">日期：</span
              ><span class="white-text">2021.06.25</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">最终得分78.5</div>
          <div class="line-right">
            <el-button type="primary" @click="dialogTableVisible2 = true"
              >曲线详情</el-button
            >
            <el-button type="primary" @click="dialogTableVisible = true"
              >评分标准</el-button
            >
            <el-button type="warning">{{
              $t("m.commentDetail.saveChange")
            }}</el-button>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">名称</span>
            <el-input placeholder="名称" type="text" v-model="name"> </el-input>
          </div>
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">日期</span>
            <el-date-picker
              v-model="date"
              type="date"
              prefix-icon="none"
              :clearable="false"
              :placeholder="$t('m.table.selectDate')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="flex input-line">
          <div class="flex input-wrap has-title" style="width:100%;">
            <span class="cus-input-title">{{
              $t("m.commentDetail.remark")
            }}</span>
            <el-input placeholder=""> </el-input>
          </div>
        </div>
      </section>
      <!--------杯测评分---------->
      <section
        class="scroll-section"
        style="max-height:calc(100% - 126px);overflow:auto;"
      >
        <div class="box-header-left flex flex-center" style="margin-top: 25px">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="active1 = 1"
            >杯测评分 46.3</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="active1 = 2"
            >烘焙瑕疵 20.5</span
          >
        </div>
        <section v-if="active1 == 1">
          <div class="bc-quare">
            <div class="bc-item">
              <div class="flex flex-between">
                <span>干香/湿香</span>
                <span class="orange-text">{{ valueR }}</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="6"
                      :max="10"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 5" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i + 5 }}</span
                  >
                </div>
              </div>
              <div class="ruler-box2">
                <span>干</span>
                <div class="ruler-h2 flex">
                  <span v-for="i in 5" :key="i" @click="active = i">
                    <i class="ruler-h2-num" :class="{ active: i == active }">{{
                      i
                    }}</i>
                  </span>
                </div>
              </div>
              <div class="ruler-box2">
                <span>湿</span>
                <div class="ruler-h2 flex">
                  <span v-for="i in 5" :key="i" @click="active = i">
                    <i class="ruler-h2-num" :class="{ active: i == active }">{{
                      i
                    }}</i>
                  </span>
                </div>
              </div>
              <el-input placeholder="输入描述" type="text" class="ruler-input">
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>风味</span>
                <span class="orange-text">7.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="6"
                      :max="10"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 5" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i + 5 }}</span
                  >
                </div>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>余韵</span>
                <span class="orange-text">7.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="6"
                      :max="10"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 5" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i + 5 }}</span
                  >
                </div>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
          </div>
          <div class="bc-quare">
            <div class="bc-item">
              <div class="flex flex-between">
                <span>酸质</span>
                <span class="orange-text">{{ valueR }}</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="6"
                      :max="10"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 5" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i + 5 }}</span
                  >
                </div>
              </div>
              <div class="ruler-line">强度</div>
              <div class="ruler-box2">
                <span>低</span>
                <div class="ruler-h2 flex">
                  <span v-for="i in 5" :key="i" @click="active = i">
                    <i class="ruler-h2-num" :class="{ active: i == active }">{{
                      i
                    }}</i>
                  </span>
                </div>
                <span style="margin-left:5px;">高</span>
              </div>
              <el-input placeholder="输入描述" type="text" class="ruler-input">
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>体脂感</span>
                <span class="orange-text">7.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="6"
                      :max="10"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 5" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i + 5 }}</span
                  >
                </div>
              </div>
              <div class="ruler-line">程度</div>
              <div class="ruler-box2">
                <span>低</span>
                <div class="ruler-h2 flex">
                  <span v-for="i in 5" :key="i" @click="active = i">
                    <i class="ruler-h2-num" :class="{ active: i == active }">{{
                      i
                    }}</i>
                  </span>
                </div>
                <span style="margin-left:5px;">高</span>
              </div>
              <el-input placeholder="输入描述" type="text" class="ruler-input">
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>甜度</span>
                <span class="orange-text">7.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="6"
                      :max="10"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 5" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i + 5 }}</span
                  >
                </div>
              </div>
              <div class="ruler-box2">
                <span>发展度</span>
                <div class="ruler-h2 flex">
                  <span v-for="i in 4" :key="i" @click="active = i">
                    <i class="ruler-h2-num" :class="{ active: i == active }">{{
                      i
                    }}</i>
                  </span>
                </div>
              </div>
              <div
                class="ruler-line2"
                style="margin-bottom: 6px; margin-top: 6px"
              >
                <span>巧克力</span>
                <span>糖果</span>
                <span>甜橙</span>
              </div>
              <el-input placeholder="输入描述" type="text" class="ruler-input">
              </el-input>
            </div>
          </div>
          <div class="bc-quare">
            <div class="bc-item">
              <div class="flex flex-between">
                <span>平衡性</span>
                <span class="orange-text">{{ valueR }}</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="6"
                      :max="10"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 5" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i + 5 }}</span
                  >
                </div>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>风味描述</span>
                <span class="orange-text">7.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="6"
                      :max="10"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 5" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i + 5 }}</span
                  >
                </div>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>杯测总体描述</span>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
          </div>
        </section>
        <section v-if="active1 == 2">
          <div class="bc-quare">
            <div class="bc-item">
              <div class="flex flex-between">
                <span>发展未成熟</span>
                <span class="orange-text">2.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="0"
                      :max="5"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 21" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 6" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i - 1 }}</span
                  >
                </div>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>发展过度</span>
                <span class="orange-text">2.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="0"
                      :max="5"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 21" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 6" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i - 1 }}</span
                  >
                </div>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>烘焙</span>
                <span class="orange-text">2.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="0"
                      :max="5"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 21" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 6" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i - 1 }}</span
                  >
                </div>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
          </div>
          <div class="bc-quare">
            <div class="bc-item">
              <div class="flex flex-between">
                <span>表面烧焦</span>
                <span class="orange-text">2.5</span>
              </div>
              <div class="ruler-box">
                <div class="ruler-h flex">
                  <div class="line-top">
                    <el-slider
                      v-model="valueR"
                      :min="0"
                      :max="5"
                      :step="0.25"
                      :show-tooltip="false"
                    ></el-slider>
                  </div>
                  <span v-for="i in 21" :key="i" :class="`ruler-${i}`"></span>
                </div>
                <div class="ruler-text">
                  <span v-for="i in 6" :key="i"
                    ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                    >{{ i - 1 }}</span
                  >
                </div>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
            <div class="bc-item">
              <div class="flex flex-between">
                <span>瑕疵总描述</span>
              </div>
              <el-input
                placeholder="输入描述"
                type="textarea"
                class="ruler-input"
              >
              </el-input>
            </div>
            <div class="bc-item"></div>
          </div>
        </section>
      </section>
    </div>
    <!--------评分标准弹框---------->
    <el-dialog title="评分标准" :visible.sync="dialogTableVisible">
      <el-table :data="gridData" width="100%">
        <el-table-column label="Quarlity Scale">
          <el-table-column property="good" label="6.00-Good"></el-table-column>
          <el-table-column
            property="veryGood"
            label="7.00-VeryGood"
          ></el-table-column>
          <el-table-column
            property="excellent"
            label="8.00-Excellent"
          ></el-table-column>
          <el-table-column
            property="outstanding"
            label="9.00-Outstanding"
          ></el-table-column>
        </el-table-column>
      </el-table>
      <div class="text-white" style="margin-top:10px;">杯测打分说明</div>
      <div class="bc-classfy-line">
        <div class="classfy-line-item">
          <span class="item-title">好：</span>
          <span class="item-value">6-6.75</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title">非常好：</span>
          <span class="item-value">7-7.75</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title">出色：</span>
          <span class="item-value">8-8.75</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title">非凡：</span>
          <span class="item-value">9-9.75</span>
        </div>
      </div>
      <div class="text-white" style="margin-top:5px;">瑕疵打分说明</div>
      <div class="bc-classfy-line">
        <div class="classfy-line-item">
          <span class="item-title">无觉瑕疵：</span>
          <span class="item-value">0</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title">一点点：</span>
          <span class="item-value">1</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title">明显察觉：</span>
          <span class="item-value">3</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title">压倒性：</span>
          <span class="item-value">5</span>
        </div>
      </div>
    </el-dialog>
    <!--------曲线详情---------->
    <el-dialog
      :title="$t('m.deviceManage.bindDevice.operation.detail')"
      :visible.sync="dialogTableVisible2"
    >
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">曲线详情</span>
        </div>
        <div class="has-total-table">
          <el-table
            :data="gridData3"
            border
            style="width:100%;"
            class="has-total-table"
          >
            <el-table-column
              property="key1"
              :label="$t('m.table.name')"
            ></el-table-column>
            <el-table-column property="key2" label="类别"></el-table-column>
            <el-table-column property="key3" label="事件"></el-table-column>
            <el-table-column property="key4" label="时间"></el-table-column>
            <el-table-column property="key5" label="重量"></el-table-column>
          </el-table>
          <div class="table-totla-line">
            <span class="gray-text">总重量:</span>
            <span class="white-text">650kg</span>
          </div>
        </div>
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">描述</span>
        </div>
        <div class="row-box">
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">序列号：</span>
                <span class="white-text">23213123123</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">机器型号：</span>
                <span class="white-text">43242</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">烘焙时长：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">发展时间：</span>
                <span class="white-text">2021.06.01</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">发展率：</span>
                <span class="white-text">15</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">入豆温：</span>
                <span class="white-text">生豆一</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">回温点：</span>
                <span class="white-text">导入</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">转黄点：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">一爆：</span>
                <span class="white-text">340</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">二爆：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">结束：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">回温至黄点温升：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">黄点至一爆温升：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">一爆至结束温升：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">过程</span>
        </div>
        <el-table :data="gridData2" border style="width:100%;">
          <el-table-column
            property="key1"
            width="60px"
            label="时间"
          ></el-table-column>
          <el-table-column
            property="key2"
            width="60px"
            label="豆温"
          ></el-table-column>
          <el-table-column
            property="key3"
            width="60px"
            label="ROR"
          ></el-table-column>
          <el-table-column
            property="key4"
            width="70px"
            label="热风温"
          ></el-table-column>
          <el-table-column
            property="key5"
            width="70px"
            label="出风温"
          ></el-table-column>
          <el-table-column
            property="key6"
            width="70px"
            label="环境温"
          ></el-table-column>
          <el-table-column
            property="key7"
            width="60px"
            label="火力"
          ></el-table-column>
          <el-table-column
            property="key8"
            width="60px"
            label="热风"
          ></el-table-column>
          <el-table-column
            property="key9"
            width="60px"
            label="滚筒"
          ></el-table-column>
          <el-table-column property="key10" label="标记"></el-table-column>
        </el-table>
      </section>
      <section>
        <div class="flex" style="justify-content:flex-end;margin-top:20px;">
          <div class="line-right">
            <el-button type="primary">导出PDF</el-button>
            <el-button type="primary">导出JSON</el-button>
          </div>
        </div>
      </section>
    </el-dialog>
    <!--------搜索弹框---------->
    <el-dialog
      title="搜索"
      :visible.sync="dialogTableVisible3"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按序列号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按用户名</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按手机号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按地址</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible3 = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div
          type="primary"
          @click="dialogTableVisible3 = false"
          class="dialog-footer-btn"
        >
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "allUserCupList",
  data() {
    return {
      valueR: 7,
      active: 2,
      active1: 1,
      name: "",
      date: "",
      selectValue: "",
      options: [
        {
          label: "等级一",
          value: "1",
        },
        {
          label: "等级二",
          value: "2",
        },
      ],
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      dialogTableVisible3: false,
      gridData: [
        {
          good: "6.25",
          veryGood: "7.25",
          excellent: "8.25",
          outstanding: "9.25",
        },
        {
          good: "6.50",
          veryGood: "7.50",
          excellent: "8.50",
          outstanding: "9.50",
        },
        {
          good: "6.75",
          veryGood: "7.75",
          excellent: "8.75",
          outstanding: "9.75",
        },
      ],
      gridData2: [
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
      ],
      gridData3: [
        {
          key1: "卡图拉",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "新世界",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "斯考特实验室精选",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "法国传教士",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "铁皮卡",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
      ],
      moveFlag: false,
    };
  },
  methods: {},
};
</script>
